import { setJwtToken } from '~/api/utils';

function readCookieValue(name: string): string | undefined {
  return document.cookie.match(`(^|;)\\s*${name}\\s*=\\s*([^;]+)`)?.pop();
}

function deleteCookie(name: string) {
  const domain = window.location.hostname.split('.').splice(-2).join('.');
  document.cookie = `${name}=; domain=${domain}; path=/; expires=Thu, 01 Jan 1970 00:00:00 UTC;`;
}

export function setTokenFromCookie(): boolean {
  const jwt = readCookieValue('jwt');
  if (jwt) {
    setJwtToken(jwt);
    deleteCookie('jwt');
    return true;
  }

  return false;
}
